module.exports = __webpack_public_path__ + "static/media/400085_01.6f1eac5b.png";